import { render, staticRenderFns } from "./AddIssue.vue?vue&type=template&id=2b93d532"
import script from "./AddIssue.vue?vue&type=script&lang=js"
export * from "./AddIssue.vue?vue&type=script&lang=js"
import style0 from "./AddIssue.vue?vue&type=style&index=0&id=2b93d532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports